import client from './client';

export const getInventoryValuation = () =>
  client.get('/reports/inventory-valuation').then((r) => r.data);

export const getStockMovement = (params) =>
  client.get('/reports/stock-movement', { params }).then((r) => r.data);

export const getLowStockReport = () =>
  client.get('/reports/low-stock').then((r) => r.data);

export const getExpiryForecast = () =>
  client.get('/reports/expiry-forecast').then((r) => r.data);

export const getDeadStock = (days) =>
  client.get('/reports/dead-stock', { params: { days } }).then((r) => r.data);

export const getShrinkage = (params) =>
  client.get('/reports/shrinkage', { params }).then((r) => r.data);
